import { createContext, PropsWithChildren, useContext } from 'react';
import { Configuration } from 'bff/client';
import type { ApiClient } from './ApiClient';
import { initialiseApiClient } from './util/initialise-api-client';

const ApiClientContext = createContext<ApiClient | undefined>(undefined);

interface ApiClientProviderProps {
  apiConfig: Configuration;
}

export const ApiClientProvider = ({
  children,
  apiConfig
}: PropsWithChildren<ApiClientProviderProps>) => {
  const apiClient = initialiseApiClient(apiConfig);

  return <ApiClientContext.Provider value={apiClient}>{children}</ApiClientContext.Provider>;
};

export const useApiClient = () => {
  const context = useContext(ApiClientContext);

  if (!context) {
    throw new Error(
      'Cannot use Api Client Context outside of its Provider. Please ensure you have added the ApiClientProvider at the top of your app'
    );
  }

  return context;
};
